module.exports = __webpack_public_path__ + "img/blog-details-2.5803cf8c.jpg";